/*
  La Sura - the gift message in the basket (snippets/lasura-gift-message.liquid).

  Saves the message as an order attribute while the customer types, the way Horizon's order note
  saves (assets/cart-note.js), so it's kept if they leave the basket, and on the order for the
  kitchen. The field also posts with the basket form at checkout, as a backstop.
*/
import { debounce, fetchConfig } from '@theme/utilities';

class LasuraGiftMessage extends HTMLElement {
  /** @type {AbortController | null} */
  #active = null;

  connectedCallback() {
    this.addEventListener('input', this.#onInput);
  }

  disconnectedCallback() {
    this.removeEventListener('input', this.#onInput);
  }

  #onInput = (event) => {
    if (event.target instanceof HTMLTextAreaElement) this.#save(event.target.value);
  };

  #save = debounce(async (value) => {
    const key = this.dataset.key;
    if (!key) return;
    this.#active?.abort();
    const controller = new AbortController();
    this.#active = controller;
    try {
      await fetch(window.Theme?.routes?.cart_update_url || `${window.Shopify?.routes?.root || '/'}cart/update.js`, {
        ...fetchConfig('json', { body: JSON.stringify({ attributes: { [key]: value } }) }),
        signal: controller.signal,
      });
    } catch {
      /* Aborted by a newer keystroke, or offline: the field still posts with the form at checkout. */
    } finally {
      if (this.#active === controller) this.#active = null;
    }
  }, 300);
}

if (!customElements.get('lasura-gift-message')) customElements.define('lasura-gift-message', LasuraGiftMessage);
